import { useState } from "react";

export const UseForm = (initialValue, validate) => {
  const [values, setValues] = useState(initialValue);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((prev) => ({
      ...prev,
      [name]: value,
      
      
    }));
    console.log([name] +":"+value);
    
    //clear errors when starts typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };
  const handleSubmit = async (onSubmit) => {
    setIsSubmitting(true);
    const formErrors=validate?validate(values):{};
    if(Object.keys(formErrors).length===0){
        await onSubmit(values);
    }else{
        setErrors(formErrors);
    }
    setIsSubmitting(false);
  };
  const reset=()=>{
    setValues(initialValue);
    setErrors({});
  }

  return{
    values,
    errors,
    isSubmitting,
    handleChange,
    handleSubmit,
    reset,
    setErrors
  }
};
